"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var device_detection_1 = require("../utils/device-detection");
var convertUIConfigForIOS = function (params) { return (tslib_1.__assign({}, params, { showInteractionIndicator: false, screen: tslib_1.__assign({}, params.screen, { disableClickProcessing: true, nativeControls: true }), title: false, loader: false, controls: false })); };
var convertUIConfigForAndroid = function (params) { return (tslib_1.__assign({}, params, { screen: tslib_1.__assign({}, params.screen, { disableClickProcessing: true }) })); };
var convertToDeviceRelatedConfig = function (params) {
    if (device_detection_1.isIOS()) {
        return convertUIConfigForIOS(params);
    }
    if (device_detection_1.isAndroid()) {
        return convertUIConfigForAndroid(params);
    }
    return params;
};
exports.default = convertToDeviceRelatedConfig;
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/core/config.js
// module id = 43
// module chunks = 0